import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Facebook, Instagram, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark text-white pt-16 pb-8 border-t-4 border-light-blue" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-53">
          {/* Company Info */}
          <div data-id="element-54">
            <img src="https://cdn.magicpatterns.com/uploads/5AVKXiTXV1VVA3kGuFBhc2/TheSoftwashPros-logo.jpg" alt="Softwash Pros Logo" className="h-16 bg-white rounded p-1 mb-6" data-id="element-55" />
            <p className="text-gray-400 mb-6" data-id="element-56">
              Professional soft washing and exterior cleaning services. We
              restore your property's beauty safely and effectively.
            </p>
            <div className="flex space-x-4" data-id="element-57">
              <a href="#" className="w-10 h-10 rounded-full bg-navy flex items-center justify-center hover:bg-light-blue hover:text-dark transition-colors" data-id="element-58">
                <Facebook className="w-5 h-5" data-id="element-59" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-navy flex items-center justify-center hover:bg-light-blue hover:text-dark transition-colors" data-id="element-60">
                <Instagram className="w-5 h-5" data-id="element-61" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-62">
            <h4 className="text-xl font-montserrat font-bold mb-6 text-white" data-id="element-63">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-64">
              <li data-id="element-65">
                <Link to="/" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-66">
                  Home
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/about" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-68">
                  About Us
                </Link>
              </li>
              <li data-id="element-69">
                <Link to="/services" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-70">
                  Our Services
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/gallery" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-72">
                  Before & After Gallery
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/contact" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-74">
                  Contact / Free Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-75">
            <h4 className="text-xl font-montserrat font-bold mb-6 text-white" data-id="element-76">
              Our Services
            </h4>
            <ul className="space-y-3" data-id="element-77">
              <li data-id="element-78">
                <Link to="/services/residential" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-79">
                  Residential Soft Washing
                </Link>
              </li>
              <li data-id="element-80">
                <Link to="/services/roof" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-81">
                  Roof Cleaning
                </Link>
              </li>
              <li data-id="element-82">
                <Link to="/services/gutter" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-83">
                  Gutter Cleaning
                </Link>
              </li>
              <li data-id="element-84">
                <Link to="/services/driveway" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-85">
                  Driveway & Concrete
                </Link>
              </li>
              <li data-id="element-86">
                <Link to="/services/deck" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-87">
                  Deck & Patio Cleaning
                </Link>
              </li>
              <li data-id="element-88">
                <Link to="/commercial" className="text-gray-400 hover:text-light-blue transition-colors" data-id="element-89">
                  Commercial Soft Washing
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-90">
            <h4 className="text-xl font-montserrat font-bold mb-6 text-white" data-id="element-91">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-92">
              <li className="flex items-start" data-id="element-93">
                <Phone className="w-5 h-5 text-light-blue mr-3 mt-1 shrink-0" data-id="element-94" />
                <div data-id="element-95">
                  <span className="block text-sm text-gray-400" data-id="element-96">
                    Call for a Free Quote
                  </span>
                  <a href="tel:586-298-2727" className="text-lg font-bold hover:text-light-blue transition-colors" data-id="element-97">
                    586-298-2727
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-98">
                <Mail className="w-5 h-5 text-light-blue mr-3 mt-1 shrink-0" data-id="element-99" />
                <div data-id="element-100">
                  <span className="block text-sm text-gray-400" data-id="element-101">Email Us</span>
                  <a href="mailto:SoftwashPros@gmail.com" className="hover:text-light-blue transition-colors" data-id="element-102">
                    SoftwashPros@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-103">
                <MapPin className="w-5 h-5 text-light-blue mr-3 mt-1 shrink-0" data-id="element-104" />
                <div data-id="element-105">
                  <span className="block text-sm text-gray-400" data-id="element-106">
                    Service Area
                  </span>
                  <span className="text-gray-300" data-id="element-107">
                    Proudly serving the local area and surrounding communities.
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-108">
          <p className="text-gray-500 text-sm mb-4 md:mb-0" data-id="element-109">
            &copy; {new Date().getFullYear()} Softwash Pros. All Rights
            Reserved.
          </p>
          <div className="flex space-x-4 text-sm text-gray-500" data-id="element-110">
            <Link to="#" className="hover:text-white transition-colors" data-id="element-111">
              Privacy Policy
            </Link>
            <span data-id="element-112">|</span>
            <Link to="#" className="hover:text-white transition-colors" data-id="element-113">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}